import RegionMap from './RegionMap';

export default RegionMap;
